import { render, staticRenderFns } from "./areaBlogArticle.vue?vue&type=template&id=adb66ed8&scoped=true"
import script from "./areaBlogArticle.vue?vue&type=script&lang=js"
export * from "./areaBlogArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb66ed8",
  null
  
)

export default component.exports